<template>
  <div class="media media-comment">
    <img alt="Image placeholder" class="avatar avatar-lg media-comment-avatar rounded-circle" :src="avatarUrl" />
    <div class="media-body">
      <div class="media-comment-text" :class="{ confidential: !shareComment }">
        <div class="d-flex align-items-baseline">
          <h6 class="h5 mt-0">{{ userName }}</h6>
          <badge v-if="userRole" class="m-1" type="primary">
            <span class="mr-1">{{ userRole }}</span>
          </badge>
          <div v-if="!shareComment"><p style="font-style: italic">Comentario PRIVADO</p></div>
        </div>
        <p class="text-sm lh-160" v-html="text"></p>
        <div v-if="showSocialNumbers" class="icon-actions">
          <a href="#" class="like active">
            <i class="ni ni-like-2"></i>
            <span class="text-muted">{{ likeCount }} likes</span>
          </a>
          <a href="#">
            <i class="ni ni-curved-next"></i>
            <span class="text-muted">{{ shareCount }} shares</span>
          </a>
        </div>
        <p v-if="date.length > 0" class="comment-date">{{ date | date('DD/MM/YYYY HH:mm') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Comment',
  props: {
    userName: {
      type: String,
      default: 'Michael Lewis',
    },

    userRole: {
      type: String,
      default: '',
    },

    date: {
      type: String,
      default: '',
    },

    text: {
      type: String,
      default: '',
    },

    showSocialNumbers: {
      type: Boolean,
      default: false,
    },

    likeCount: {
      type: Number,
      default: 0,
    },

    shareCount: {
      type: Number,
      default: 0,
    },

    shareComment: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    avatarUrl() {
      let name = this.$props.userName.replace(' ', '');
      return 'https://api.kwelo.com/v1/media/identicon/' + name;
    },
  },
};
</script>

<style lang="scss" scoped>
.media-comment {
  .comment-date {
    font-size: 12px;
    font-style: italic;
  }
}

.confidential {
  background-color: #d1d6dbc2;
}
</style>
